import React, { ReactNode, useReducer } from "react";
import {
  initialState,
  reducer,
  RouteAction,
  RouteState,
} from "../../service/route.reducer";

export const RouteContext = React.createContext<{
  state: RouteState;
  dispatch: React.Dispatch<RouteAction>;
}>({
  state: initialState,
  dispatch: () => undefined,
});

export interface ProviderProps {
  children: ReactNode;
}

export const RouteProvider = (props: ProviderProps) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <RouteContext.Provider value={{ state, dispatch }}>
      {props.children}
    </RouteContext.Provider>
  );
};
